import React from 'react';

import MyAppBar from '../../components/MyAppBar';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

export default function B(props) {
  return (
    <React.Fragment>
      <MyAppBar title='Appendix B - Special Provision Description' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          {window.config.client === 'FT-BEND' ? (
            <>
              <p>
                The District staff requires a special provision on any wells
                that are in Regulatory Area A that have an allocation greater
                than 10.0 MG per year or a total pumpage greater than 5.0 MG, or
                have not converted to alternate water. The special provision is
                as follows:
              </p>
              <p sx={styles.indent}>
                On August 28, 2013 the Board of Directors of the Fort Bend
                Subsidence District adopted the 2013 District Regulatory Plan.
                You can obtain a copy of the 2013 District Plan at our web site{' '}
                <a
                  href='https://www.fbsubsidence.org'
                  target='_blank'
                  rel='noreferrer'
                >
                  https://www.fbsubsidence.org
                </a>
                . If you have any questions or if you do not have access to the
                Internet, you can contact the District office at{' '}
                <a href='tel:2813423273'>281-342-3273</a>.
              </p>
              <p>
                This provision may not have been included on every
                recommendation (meeting the above criteria) in this Hearing
                Examiner's Report, but the provision is required for these wells
                and is considered a part of staff recommendation for each well
                that meets the criteria and will be included on the permit for
                each well that meets the criteria.
              </p>
              <p>Other provisions are as follows:</p>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell>Provision</TableCell>
                    <TableCell>Description</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>PROV-40</TableCell>
                    <TableCell>
                      Limited to no more than 40% of the total water demand.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-70</TableCell>
                    <TableCell>
                      Limited to no more than 70% of the total water
                      demand-These permittees have a Groundwater Reduction Plan
                      (GRP).
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-A</TableCell>
                    <TableCell>
                      Permittee is required to submit a report on how they can
                      improve the accountability of the water system. The
                      accountability is the amount of water that billed
                      (accounted for through meter readings) versus pumped from
                      their wells or other sources.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {window.config.client === 'FT-BEND'
                        ? 'PROV-D2'
                        : 'PROV-D1'}
                    </TableCell>
                    <TableCell>
                      This provision is used to make permittees aware that the
                      District has updated its District Plan. This provision is
                      added to those permittees with an allocation between 5.0
                      and 10.0 MG that are located in Regulatory Area A.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-DF6</TableCell>
                    <TableCell>
                      Limited to no more than 40% of the total water demand plus
                      an additional amount of water covered by the permittee
                      paying the disincentive fee.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-E</TableCell>
                    <TableCell>
                      The authorized allocation is for the total aggregate
                      system.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-F</TableCell>
                    <TableCell>
                      This provision is used to make permittees aware that there
                      might be violation associated with the permit.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-G</TableCell>
                    <TableCell>
                      Provision giving the permittee notice that by a certain
                      date they will be ordered to reduce their groundwater
                      usage by 60% of the total water demand.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-G1A</TableCell>
                    <TableCell>
                      This provision is used for those permittees stating that
                      they are exempt from paying the disincentive fee because
                      they have an approved (GRP). The "A" refers to the 2013
                      Regulatory Plan.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-G2</TableCell>
                    <TableCell>
                      This provision is used when a permittee has a groundwater
                      reduction agreement with another permittee. The permittee
                      would pay the other permittee to over convert, so that the
                      first permittee can remain on groundwater. Currently,
                      there are no agreements of this type in the District.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-G4</TableCell>
                    <TableCell>
                      Limited to no more than 40% of the total water demand plus
                      an additional amount of water covered by the permittee
                      using groundwater credits/paying the disincentive fee.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-JASP1</TableCell>
                    <TableCell>
                      This provision is currently used for only one well in the
                      District, that is drilled into the Jasper Aquifer.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-M</TableCell>
                    <TableCell>
                      Giving the permittee notice that they have 60 days to
                      install a meter.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-O</TableCell>
                    <TableCell>
                      Giving the permittee notice that they until a certain date
                      to install a meter.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-SP40</TableCell>
                    <TableCell>
                      Limited to no more than 40% of the total water demand plus
                      an additional amount of water covered by the permittee's
                      use of groundwater credits.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>PROV-U1</TableCell>
                    <TableCell>
                      Provision requesting that the permittee submit a report on
                      what options that may be available to them, other than
                      groundwater.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </>
          ) : (
            <>
              <p>
                The District staff requires a special provision on any wells
                that are in Regulatory Areas 1, 2, or 3 that have an allocation
                greater than 10.0 MG per year or a total pumpage greater than
                5.0 MG, or have not converted to alternate water. The special
                provision is as follows:
              </p>
              <p sx={styles.indent}>
                On January 9, 2013 the Board of Directors of the Subsidence
                District adopted the 2013 District Regulatory Plan. There have
                been significant changes between the 1999 and the 2013 District
                Plans. As a result, some of the changes may directly affect you.
                You can obtain a copy of the 2013 District Plan at our web site
                www.subsidence.org. If you have any questions or if you do not
                have access to the Internet, you can contact the Subsidence
                District's office.
              </p>
              <p>
                This provision may not have been included on every
                recommendation (meeting the above criteria) in this Hearing
                Examiner's Report, but the provision is required for these wells
                and is considered a part of staff recommendation for each well
                that meets the criteria. The provision will be included on the
                permit for each well that meets the criteria.
              </p>
            </>
          )}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
